import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Plus } from 'lucide-react';
import api from '../../utils/api';
import { useTenant } from '../../context/TenantContext';
import { toast } from 'sonner';

const statusClass = (status) => {
  if (status === 'Cerrado') return 'bg-emerald-500/15 text-emerald-700';
  if (status === 'Pendiente cliente') return 'bg-amber-500/15 text-amber-700';
  return 'bg-blue-500/15 text-blue-700';
};

const Requests = () => {
  const navigate = useNavigate();
  const { activeTenant, onboardingStatus } = useTenant();
  const [requests, setRequests] = useState([]);
  const isReadyToOperate = onboardingStatus?.is_ready_to_operate === true;

  const loadRequests = async () => {
    if (!activeTenant) return;
    try {
      const res = await api.get(`/requests/tenant/${activeTenant}`);
      setRequests(res.data || []);
    } catch (error) {
      toast.error('Error cargando solicitudes');
    }
  };

  useEffect(() => {
    loadRequests();
  }, [activeTenant]);

  return (
    <div data-testid="requests-page" className="max-w-5xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-4xl font-heading font-bold">Solicitudes</h1>
          <p className="text-muted-foreground">Crea solicitudes estructuradas y sigue su estado</p>
        </div>
        <Button
          className="gap-2"
          data-testid="create-request-button"
          disabled={!isReadyToOperate}
          onClick={() => navigate('/client/requests/new')}
        >
          <Plus className="w-4 h-4" /> Nueva Solicitud
        </Button>
      </div>

      <Card>
        <CardContent className="p-0">
          <div className="divide-y">
            {requests.length === 0 ? (
              <div className="px-6 py-8 text-center text-muted-foreground">No hay solicitudes</div>
            ) : (
              requests.map((req) => (
                <div key={req.id} className="px-6 py-4 hover:bg-muted/50" data-testid={`request-${req.id}`}>
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <h3 className="font-medium">{req.request_type_name || req.title}</h3>
                      <p className="text-sm text-muted-foreground mt-1">
                        {new Date(req.created_at).toLocaleString('es-ES')}
                      </p>
                    </div>
                    <span className={`px-2 py-1 rounded text-xs ${statusClass(req.status)}`}>
                      {req.status}
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Requests;
